import hintIconBg from './hint_icon.svg';
import { DELIVERY_HINT_POSITIONS, type DeliveryHintDirection } from './deliveryHintPositions';
import './DeliveryHintIcon.css';

export type DeliveryHintIconProps = {
  direction: DeliveryHintDirection;
  /** Figma `value_text` — off-screen active delivery count for this arrow. */
  value: number | string;
  className?: string;
};

/**
 * Figma deliveries_count badge next to map arrows.
 * Background from hint_icon.svg; value_text is dynamic HTML.
 */
export function DeliveryHintIcon({
  direction,
  value,
  className,
}: DeliveryHintIconProps) {
  const position = DELIVERY_HINT_POSITIONS[direction];
  const text = String(value);
  const compact = text.length > 1;

  return (
    <div
      className={[
        'delivery-hint-icon',
        `delivery-hint-icon--${direction}`,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={{ left: position.left, top: position.top }}
      aria-hidden
    >
      <div className="delivery-hint-icon__shift">
        <img
          className="delivery-hint-icon__bg"
          src={hintIconBg}
          alt=""
          draggable={false}
        />
        <p
          className={[
            'delivery-hint-icon__value',
            compact ? 'delivery-hint-icon__value--compact' : '',
          ]
            .filter(Boolean)
            .join(' ')}
        >
          {text}
        </p>
      </div>
    </div>
  );
}
